<template>
  <div />
</template>
<script>
import mapboxgl from 'mapbox-gl'
import { mapState } from 'vuex'
export default {
  name: 'ScaleControl',
  control: null,
  computed: {
    ...mapState({
      mapIsLoaded: (state) => state.mapIsLoaded
    })
  },
  watch: {
    mapIsLoaded: {
      immediate: true,
      handler() {
        if (!this.mapIsLoaded) return
        const control = new mapboxgl.ScaleControl({
          unit: 'metric'
        })
        this.$store.map.addControl(control, 'bottom-right')
        this.$options.control = control
      }
    }
  },
  beforeUnmount() {
    this.$store.map.removeControl(this.$options.control)
  }
}
</script>
